import { useCallback } from "react";

type Document360Theme = "light" | "dark";
type Document360Api = {
  (command: "show" | "hide" | "toggle"): void;
  (command: "setTheme", theme: Document360Theme): void;
};

const DARK_THEME_BODY_CLASS = "theme-dark";

const getDocument360Api = (): Document360Api | undefined =>
  (window as Window & { mw?: Document360Api }).mw;

const getCurrentTheme = (): Document360Theme =>
  document.body.classList.contains(DARK_THEME_BODY_CLASS) ? "dark" : "light";

const useOpenDocWidget = () => {
  const openWidget = useCallback(() => {
    const document360 = getDocument360Api();
    if (!document360) {
      return;
    }
    document360("setTheme", getCurrentTheme());
    document360("show");
  }, []);

  return { openWidget };
};

export default useOpenDocWidget;
